export interface AzureDevOpsConfigInterface {
  organization: string;
  project: string;
  repository: string;
  personalAccessToken?: string;
  ev2BearerToken?: string; // Add optional EV2 Bearer Token
}

export const AzureDevOpsConfig: AzureDevOpsConfigInterface = {
  organization: "MsAzure",
  project: "One",
  repository: "AzureUX-Experimentation",
};

export const ibizaportalexp = "ee9fd4ce-6bba-4471-a3ce-a690e7e75039";

// Azure DevOps Pipeline Steps

// ev2ReleaseLinkStepEv2RaDeploy is the most recent step to find the ev2 link but
// ev2ReleaseLinkStep was the original step to find the ev2 link
// for now we need both because there are still experiments referencing the old release step
export const ev2ReleaseLinkStep = "Ev2 Production Region Agnostic";
export const ev2ReleaseLinkStepEv2RaDeploy = "Ev2 RA - Deploy";

export const ev2ApprovalLinkStep = "Waiting for Approval";

export const requestApprovedStep = "Request Approved";

export const approvalServiceStep = "Approval service";
